module.exports = __webpack_public_path__ + "static/media/pathStage.66e606f9.jpg";